"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteStatus = exports.ModelCodeType = exports.BosOrderStatus = exports.OrderType = exports.OrderValidation = exports.ApplicationCode = exports.SigningType = exports.VatCode = exports.OrderFlow = exports.OrderEventType = exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    OrderStatus[OrderStatus["CREATED"] = 0] = "CREATED";
    OrderStatus[OrderStatus["CONFIRMED"] = 1] = "CONFIRMED";
    OrderStatus[OrderStatus["CANCELLED"] = 2] = "CANCELLED";
    OrderStatus[OrderStatus["DRAFT_CREATED"] = 3] = "DRAFT_CREATED";
    OrderStatus[OrderStatus["REVISED"] = 4] = "REVISED";
    OrderStatus[OrderStatus["EXPIRED"] = 5] = "EXPIRED";
    OrderStatus[OrderStatus["PAUSED"] = 6] = "PAUSED";
    OrderStatus[OrderStatus["SIGNED"] = 7] = "SIGNED";
    OrderStatus[OrderStatus["COMPLETED"] = 8] = "COMPLETED";
    OrderStatus[OrderStatus["FAILURE"] = 9] = "FAILURE";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderEventType;
(function (OrderEventType) {
    OrderEventType[OrderEventType["CREATED"] = 0] = "CREATED";
    OrderEventType[OrderEventType["DELIVERED"] = 1] = "DELIVERED";
    OrderEventType[OrderEventType["PAUSED"] = 2] = "PAUSED";
    OrderEventType[OrderEventType["RESUMED"] = 3] = "RESUMED";
    OrderEventType[OrderEventType["CANCELLED"] = 4] = "CANCELLED";
    OrderEventType[OrderEventType["VEHICLE_ADDED"] = 5] = "VEHICLE_ADDED";
    OrderEventType[OrderEventType["FAILURE_VEHICLE_ADDED"] = 6] = "FAILURE_VEHICLE_ADDED";
    OrderEventType[OrderEventType["VEHICLE_REMOVED"] = 7] = "VEHICLE_REMOVED";
    OrderEventType[OrderEventType["FAILURE_VEHICLE_REMOVED"] = 8] = "FAILURE_VEHICLE_REMOVED";
    OrderEventType[OrderEventType["CUSTOMER_ADDED"] = 9] = "CUSTOMER_ADDED";
    OrderEventType[OrderEventType["FAILURE_CUSTOMER_ADD"] = 10] = "FAILURE_CUSTOMER_ADD";
    OrderEventType[OrderEventType["CUSTOMER_REMOVED"] = 11] = "CUSTOMER_REMOVED";
    OrderEventType[OrderEventType["TRADEIN_ADDED"] = 12] = "TRADEIN_ADDED";
    OrderEventType[OrderEventType["TRADEIN_REMOVED"] = 13] = "TRADEIN_REMOVED";
    OrderEventType[OrderEventType["DISCOUNT_ADJUSTED"] = 14] = "DISCOUNT_ADJUSTED";
    OrderEventType[OrderEventType["OFFER_CHOSEN"] = 15] = "OFFER_CHOSEN";
    OrderEventType[OrderEventType["FAILURE_OFFER_CHOSEN"] = 16] = "FAILURE_OFFER_CHOSEN";
    OrderEventType[OrderEventType["SIGNING_INITIATED"] = 17] = "SIGNING_INITIATED";
    OrderEventType[OrderEventType["CONTRACT_SIGNED"] = 18] = "CONTRACT_SIGNED";
    OrderEventType[OrderEventType["ACCESSORIES_UPDATED"] = 19] = "ACCESSORIES_UPDATED";
    OrderEventType[OrderEventType["CONFIRMED"] = 20] = "CONFIRMED";
    OrderEventType[OrderEventType["OFFER_EXPIRED"] = 21] = "OFFER_EXPIRED";
    OrderEventType[OrderEventType["CALCULATION_ADDED"] = 22] = "CALCULATION_ADDED";
    OrderEventType[OrderEventType["CALCULATION_REMOVED"] = 23] = "CALCULATION_REMOVED";
    OrderEventType[OrderEventType["FAILURE_CALCULATION_ADDED"] = 24] = "FAILURE_CALCULATION_ADDED";
    OrderEventType[OrderEventType["FAILURE_CALCULATION_REMOVED"] = 25] = "FAILURE_CALCULATION_REMOVED";
    OrderEventType[OrderEventType["FAILURE_FINANCE"] = 26] = "FAILURE_FINANCE";
    OrderEventType[OrderEventType["FAILURE_IFS"] = 27] = "FAILURE_IFS";
    OrderEventType[OrderEventType["RESERVATION_WAITING"] = 28] = "RESERVATION_WAITING";
    OrderEventType[OrderEventType["RESERVATION_SUCCESS"] = 29] = "RESERVATION_SUCCESS";
    OrderEventType[OrderEventType["RESERVATION_FAIL"] = 30] = "RESERVATION_FAIL";
    OrderEventType[OrderEventType["RESERVATION_CANCEL_WAITING"] = 31] = "RESERVATION_CANCEL_WAITING";
    OrderEventType[OrderEventType["RESERVATION_CANCEL_SUCCESS"] = 32] = "RESERVATION_CANCEL_SUCCESS";
    OrderEventType[OrderEventType["RESERVATION_CANCEL_FAIL"] = 33] = "RESERVATION_CANCEL_FAIL";
    OrderEventType[OrderEventType["FINANCE_APPLICATION_SENT"] = 34] = "FINANCE_APPLICATION_SENT";
    OrderEventType[OrderEventType["VEHICLE_ORDER_SENT"] = 35] = "VEHICLE_ORDER_SENT";
    OrderEventType[OrderEventType["FAILURE_VEHICLE_ACCESSORY_TOGGLE"] = 36] = "FAILURE_VEHICLE_ACCESSORY_TOGGLE";
    OrderEventType[OrderEventType["FAILURE_SIGN_CONTRACT"] = 37] = "FAILURE_SIGN_CONTRACT";
})(OrderEventType = exports.OrderEventType || (exports.OrderEventType = {}));
var OrderFlow;
(function (OrderFlow) {
    OrderFlow[OrderFlow["CREATED"] = 0] = "CREATED";
    OrderFlow[OrderFlow["SMS_SENT_CONTRACT"] = 1] = "SMS_SENT_CONTRACT";
    OrderFlow[OrderFlow["WAIT_FOR_CONTRACT_SIGNATURE"] = 2] = "WAIT_FOR_CONTRACT_SIGNATURE";
    OrderFlow[OrderFlow["CONTRACT_SIGNED"] = 3] = "CONTRACT_SIGNED";
    OrderFlow[OrderFlow["WAIT_FOR_FLEETDRIVE_SERIAL_NUMBER"] = 4] = "WAIT_FOR_FLEETDRIVE_SERIAL_NUMBER";
    OrderFlow[OrderFlow["CONFIRMED"] = 5] = "CONFIRMED";
    OrderFlow[OrderFlow["CREDIT_CHECK_INITIATED"] = 6] = "CREDIT_CHECK_INITIATED";
    OrderFlow[OrderFlow["CREDIT_CHECK_FAILURE"] = 7] = "CREDIT_CHECK_FAILURE";
    OrderFlow[OrderFlow["CREDIT_CHECK_WARNING"] = 8] = "CREDIT_CHECK_WARNING";
    OrderFlow[OrderFlow["CREDIT_CHECK_OK"] = 9] = "CREDIT_CHECK_OK";
    OrderFlow[OrderFlow["REQUEST_ADDITIONAL_DOCUMENTS"] = 10] = "REQUEST_ADDITIONAL_DOCUMENTS";
    OrderFlow[OrderFlow["SMS_SENT_DOCUMENTS"] = 11] = "SMS_SENT_DOCUMENTS";
    OrderFlow[OrderFlow["WAIT_FOR_DOCUMENT_SIGNATURE"] = 12] = "WAIT_FOR_DOCUMENT_SIGNATURE";
    OrderFlow[OrderFlow["DOCUMENTS_PARTIALLY_SIGNED"] = 13] = "DOCUMENTS_PARTIALLY_SIGNED";
    OrderFlow[OrderFlow["ALL_DOCUMENTS_SIGNED"] = 14] = "ALL_DOCUMENTS_SIGNED";
    OrderFlow[OrderFlow["WAIT_FOR_COLLECTION_DOCUMENT_FROM_BANK"] = 15] = "WAIT_FOR_COLLECTION_DOCUMENT_FROM_BANK";
    OrderFlow[OrderFlow["SEND_COLLECTION_DOCUMENT"] = 16] = "SEND_COLLECTION_DOCUMENT";
    OrderFlow[OrderFlow["ADD_INSURANCE_WHEN_REQUESTED"] = 17] = "ADD_INSURANCE_WHEN_REQUESTED";
    OrderFlow[OrderFlow["WAIT_FOR_TRACK_AND_TRACE_60"] = 18] = "WAIT_FOR_TRACK_AND_TRACE_60";
    OrderFlow[OrderFlow["ACTIVATE_SERVICES"] = 19] = "ACTIVATE_SERVICES";
    OrderFlow[OrderFlow["ACTIVATE_CONTRACT"] = 20] = "ACTIVATE_CONTRACT";
    OrderFlow[OrderFlow["WAIT_FOR_DELIVERY"] = 21] = "WAIT_FOR_DELIVERY";
    OrderFlow[OrderFlow["COLLECTION_DOCUMENT_SIGNED"] = 22] = "COLLECTION_DOCUMENT_SIGNED";
    OrderFlow[OrderFlow["VEHICLE_DELIVERY"] = 23] = "VEHICLE_DELIVERY";
    OrderFlow[OrderFlow["COLLECTION_DOCUMENT_CONTROLED"] = 24] = "COLLECTION_DOCUMENT_CONTROLED";
    OrderFlow[OrderFlow["SEND_COLLECTION_DOCUMENT_TO_BANK"] = 25] = "SEND_COLLECTION_DOCUMENT_TO_BANK";
    OrderFlow[OrderFlow["WAIT_FOR_VEHICLE_REGISTRATION_CERTIFICATE"] = 26] = "WAIT_FOR_VEHICLE_REGISTRATION_CERTIFICATE";
    OrderFlow[OrderFlow["VEHICLE_REGISTRATION_CERTIFICATE_SENT"] = 27] = "VEHICLE_REGISTRATION_CERTIFICATE_SENT";
    OrderFlow[OrderFlow["CONTRACT_ACTIVATED_IN_BYNX"] = 28] = "CONTRACT_ACTIVATED_IN_BYNX";
    OrderFlow[OrderFlow["PROCESS_VEHICLE_IN_FLEET_DRIVE"] = 29] = "PROCESS_VEHICLE_IN_FLEET_DRIVE";
    OrderFlow[OrderFlow["SEND_BILL"] = 30] = "SEND_BILL";
})(OrderFlow = exports.OrderFlow || (exports.OrderFlow = {}));
var VatCode;
(function (VatCode) {
    VatCode[VatCode["NO_VAT"] = 0] = "NO_VAT";
    VatCode[VatCode["STANDARD"] = 3] = "STANDARD";
    VatCode[VatCode["ELECTRIC"] = 5] = "ELECTRIC";
})(VatCode = exports.VatCode || (exports.VatCode = {}));
var SigningType;
(function (SigningType) {
    SigningType[SigningType["NONE"] = 0] = "NONE";
    SigningType[SigningType["DIGITAL"] = 1] = "DIGITAL";
    SigningType[SigningType["MANUAL"] = 2] = "MANUAL";
})(SigningType = exports.SigningType || (exports.SigningType = {}));
var ApplicationCode;
(function (ApplicationCode) {
    ApplicationCode["ELECTRIC"] = "EL";
    ApplicationCode["PRIVATE_CAR"] = "PB";
})(ApplicationCode = exports.ApplicationCode || (exports.ApplicationCode = {}));
var OrderValidation;
(function (OrderValidation) {
    OrderValidation["MissingCustomer"] = "MissingCustomer";
    OrderValidation["MissingCustomerReference"] = "MissingCustomerReference";
    OrderValidation["MissingCustomerReferenceBosApiId"] = "MissingCustomerReferenceBosApiId";
    OrderValidation["MissingCustomerBosApiInstance"] = "MissingCustomerBosApiInstance";
    OrderValidation["MissingCustomerSocialNumber"] = "MissingCustomerSocialNumber";
    OrderValidation["MissingInsurance"] = "MissingInsurance";
    OrderValidation["MissingInsuranceReference"] = "MissingInsuranceReference";
    OrderValidation["MissingInsuranceReferenceSantanderId"] = "MissingInsuranceReferenceSantanderId";
    OrderValidation["MissingOffer"] = "MissingOffer";
    OrderValidation["MissingUser"] = "MissingUser";
    OrderValidation["MissingUserDefaultDepartmentId"] = "MissingUserDefaultDepartmentId";
    OrderValidation["MissingUserReference"] = "MissingUserReference";
    OrderValidation["MissingUserReferenceBosApiId"] = "MissingUserReferenceBosApiId";
    OrderValidation["MissingUserReferenceSantanderId"] = "MissingUserReferenceSantanderId";
    OrderValidation["MissingVehicle"] = "MissingVehicle";
    OrderValidation["MissingVehicleReference"] = "MissingVehicleReference";
})(OrderValidation = exports.OrderValidation || (exports.OrderValidation = {}));
var OrderType;
(function (OrderType) {
    OrderType[OrderType["ORDER"] = 0] = "ORDER";
    OrderType[OrderType["RESERVE"] = 1] = "RESERVE";
    OrderType[OrderType["CANCEL_RESERVE"] = 2] = "CANCEL_RESERVE";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var BosOrderStatus;
(function (BosOrderStatus) {
    BosOrderStatus[BosOrderStatus["SUCCESS"] = 0] = "SUCCESS";
    BosOrderStatus[BosOrderStatus["FAILURE"] = 1] = "FAILURE";
})(BosOrderStatus = exports.BosOrderStatus || (exports.BosOrderStatus = {}));
var ModelCodeType;
(function (ModelCodeType) {
    ModelCodeType["KIA"] = "OCN";
    ModelCodeType["MB"] = "NO";
    ModelCodeType["PEU"] = "PRICED_OPTIONS";
})(ModelCodeType = exports.ModelCodeType || (exports.ModelCodeType = {}));
var QuoteStatus;
(function (QuoteStatus) {
    QuoteStatus["OFFER_STARTED"] = "OFFER_STARTED";
    QuoteStatus["OFFER_CREATED"] = "OFFER_CREATED";
    QuoteStatus["OFFER_SENT"] = "OFFER_SENT";
    QuoteStatus["OFFER_SIGNED"] = "OFFER_SIGNED";
    QuoteStatus["OFFER_REVISED"] = "OFFER_REVISED";
    QuoteStatus["OFFER_CANCELLED"] = "OFFER_CANCELLED";
    QuoteStatus["OFFER_EXPIRED"] = "OFFER_EXPIRED";
})(QuoteStatus = exports.QuoteStatus || (exports.QuoteStatus = {}));
//# sourceMappingURL=order.js.map